<style lang="scss">
.m2_person_sidebar {
  margin-top: 20px;
  box-sizing: border-box;
  padding: 35px 0;
  font-size: 14px;
  color: #4990e2;
  float: left;
  width: 205px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.05);
  background: white;
  .sidebar_title {
    font-size: 10px;
    color: #c2c5cf;
    padding-left: 40px;
    margin-bottom: 10px;
    padding-top: 30px;
  }
  .iconfont {
    font-size: 16px;
    color: #606266;
  }
  a {
    color: #606266;
  }
  .el-menu {
    width: 100%;
  }
  .el-menu-item,
  .el-submenu {
    .iconfont {
      margin-right: 10px;
      margin-top: 3px !important;
    }
  }
  .el-submenu__title {
    padding: 0 40px !important;
  }

  .el-menu-item {
    padding: 0 !important;

    a {
      box-sizing: border-box;
      display: block;
      width: 100%;
      height: 100%;
      padding: 0 40px !important;
    }
  }
  .el-menu-item.is-active {
    background-color: #ecf5ff;
  }
  .el-menu-item.is-active * {
    color: #409eff;
  }
  .el-menu-item-group__title {
    padding: 0;
  }
  .el-menu-item-group {
    .el-menu-item {
      padding: 0 !important;
      a {
        padding: 0 65px !important;
      }
    }
  }
}
</style>
<template>
  <div class="m2_person_sidebar">
    <div class="sidebar_title">考试信息</div>
    <el-menu
      :default-active="activeIndex"
      :default-openeds="[activeIndex.split('-')[0]]"
      class="el-menu-vertical-demo"
      @open="handleOpen"
    >
      <el-menu-item index="1"  v-if="isHideCertificate">
        <router-link :to="{name:'default.certificate'}">
          <i class="icon-zhengshu iconfont"></i>
          <span>证书中心</span>
        </router-link>
      </el-menu-item>
      <el-submenu index="2" v-if="exam_type!=1">
        <template slot="title">
          <i class="icon-shijuan iconfont"></i>
          <span>考试报名</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" v-if="">
            <router-link :to="{name:'default_myRegister'}">我的报考</router-link>
          </el-menu-item>
          <el-menu-item index="2-2" v-if="isHideExam">
            <router-link :to="{name:'default.examReg.chooseBatch'}">网上报名</router-link>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="9" v-if="exam_type!=2">
        <template slot="title">
          <i class="iconfont icon-yuyue"></i>
          <span>预约考试</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="9-1">
            <router-link :to="{name:'order.chooseBatch'}">马上预约</router-link>
          </el-menu-item>
          <el-menu-item index="9-2">
            <router-link :to="{name:'default_myReservation'}">我的预约</router-link>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3" v-if="exam_type!=1&&excuseExam==1">
        <template slot="title">
          <i class="icon-mianshi iconfont"></i>
          <span>{{$t('header.exemptionApplication')}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1">
            <router-link :to="{name:'default_myExcuse'}">{{$t('sidebar.myExemption')}}</router-link>
          </el-menu-item>
          <el-menu-item index="3-2">
            <router-link :to="{name:'excuseExam.chooseBatch'}">{{$t('header.exemptionApplication')}}</router-link>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="4" v-if="isHideAdmissionTicket">
        <router-link :to="{name:'print'}">
          <i class="icon-dayin iconfont"></i>
          <span>{{$t('header.admissionTicketPrinting')}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="5" v-if="isHideGrade">
        <router-link :to="{name:'grade'}">
          <i class="icon-chaxun1 iconfont"></i>
          <span>{{$t('header.resultInquiry')}}</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="6" v-if="exam_type!=1&&invoice_is_open==1">
        <router-link :to="{name:'default_myInvoice'}">
          <i class="icon-fapiao iconfont"></i>
          <span>我的发票</span>
        </router-link>
      </el-menu-item>
    </el-menu>
    <div class="sidebar_title">用户信息</div>
    <el-menu
      :default-active="activeIndex"
      :default-openeds="activeIndex.split('-')"
      class="el-menu-vertical-demo"
      @open="handleOpen"
    >
      <el-menu-item index="7">
        <router-link :to="{name:'default_userInform'}">
          <i class="icon-credentials_icon iconfont"></i>
          <span>个人信息</span>
        </router-link>
      </el-menu-item>
      <el-menu-item index="8">
        <router-link :to="{name:'default_safeProblem'}">
          <i class="icon-anquan iconfont"></i>
          <span>账户安全</span>
        </router-link>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      exam_type: this.$store.state.examInfo.currentExamInfo.exam_type,
      excuseExam: this.$store.state.examInfo.currentExamInfo
        .exempt_exam_is_open,
      invoice_is_open: this.$store.state.examInfo.currentExamInfo
        .invoice_is_open,
      domain: this.$store.state.examInfo.currentExamInfo.domain
    };
  },
  computed: {
    isHideExam: {
      get() {
        if (this.$store.state.examInfo.currentExamInfo.function_module) {
          return this.$store.state.examInfo.currentExamInfo.function_module.filter(
            item => {
              return item.module_type == "entry_examination_module";
            }
          )[0].selected;
        } else {
          return 0;
        }
      }
    },
    isHideCertificate: {
      get() {
        if (this.$store.state.examInfo.currentExamInfo.function_module) {
          return this.$store.state.examInfo.currentExamInfo.function_module.filter(
            item => {
              return item.module_type == "certificate_module";
            }
          )[0].selected;
        } else {
          return 0;
        }
      }
    },
    isHideAdmissionTicket: {
      get() {
        if (this.$store.state.examInfo.currentExamInfo.function_module) {
          return this.$store.state.examInfo.currentExamInfo.function_module.filter(
            item => {
              return item.module_type == "examination_permit_module";
            }
          )[0].selected;
        } else {
          return 0;
        }
      }
    },
    isHideGrade: {
      get() {
        if (this.$store.state.examInfo.currentExamInfo.function_module) {
          return this.$store.state.examInfo.currentExamInfo.function_module.filter(
            item => {
              return item.module_type == "results_release_module";
            }
          )[0].selected;
        } else {
          return 0;
        }
      }
    }
  },
  props: {
    activeIndex: {
      type: String,
      default: "0"
    }
  },
  methods: {
    handleOpen(key, keyPath) {}
  }
};
</script>
